// @flow
'use strict';

import * as React from 'react';

import type { ICobranca } from '../types';

import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';
import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import TableDetalhes from '../../../common/detalhes_documento/table_detalhes';

type CobrancaProps = {
  cobranca : ICobranca,
};

export default function Cobranca({ cobranca } : CobrancaProps) {
  if (!cobranca)
    return <h4 className="text-center" style={ { fontStyle: 'italic' } }>Nenhuma cobrança informada no CT-e.</h4>

  return (
    <div className="tab-pane active">
      <h3>Cobrança</h3>
      <h4>Fatura</h4>
      <RowDetalhes data={ cobranca }>
        <ColumnDetalhes field="numero" width="25%">Número</ColumnDetalhes>
        <ColumnDetalhes field="valorOriginal" type="moeda" width="25%">Valor Original</ColumnDetalhes>
        <ColumnDetalhes field="valorDesconto" type="moeda" width="25%">Valor Desconto</ColumnDetalhes>
        <ColumnDetalhes field="valorLiquido" type="moeda" width="25%">Valor Líquido</ColumnDetalhes>
      </RowDetalhes>

      <h4>Duplicatas</h4>
      <TableDetalhes data={ cobranca?.duplicatas } noDataClass="padding-10" noDataMsg="Nenhuma duplicata informada no CT-e.">
        <ColumnDetalhes field="numero" width="33%">Número</ColumnDetalhes>
        <ColumnDetalhes field="vencimento" type="data" width="34%">Vencimento</ColumnDetalhes>
        <ColumnDetalhes field="valor" type="moeda" width="33%">Valor</ColumnDetalhes>
      </TableDetalhes>
    </div>
  );
}
